import React, { useEffect, useRef, useState } from "react";
import Buttons from "../../../../../library/custom/button/Button";
import SearchIcon from "@mui/icons-material/Search";
import FilterListIcon from "@mui/icons-material/FilterList";
import UserFilterList from "../../../shared/UserFilterList ";
import {
  GRID_DEFAULT_PAGE_SIZE,
  ORG_ID,
  ROW_PER_PAGE_SIZE,
} from "../../../../../constant/constant";
import GridTable from "../../../../../library/custom/gridTable/GridTable";
import ReportRowManipulte from "../../../../incidents/incidentList/ReportRowManipulte";
import NORow from "../../../../../library/custom/noRow/noRow";
import { TableLoader } from "../../../../../library/common/Loader";
import {
  ADMIN_CONTRACTOR_CONFIGURATION_EDIT,
  ADMIN_CONTRACTOR_CONFIGURATION_VIEW,
} from "../../../../../constant/routeContant";
import { useNavigate } from "react-router-dom";
import { checkPrivileges } from "../../../../../utils/rolesHelper";
import downloadIcon from "../../../../../assets/downloadIcon.svg";
import { InactiveClient } from "../../../../../utils/helper";
import check_Icon from "../../..../../../../../assets/check_Icon.svg";
import cross_Icon from "../../..../../../../../assets/cross_Icon.svg";
import { useDebounce } from "../../../../../utils/useDebounceSearch";

function ContractorConfigurationList({
  OnboardedContractorListData,
  getOnboardedContractorLists,
  OnboardedContractorListDataList,
  loading,
  updateOnboardedContractorList,
  recreateUsersList,
  onboardContractorStatus,
  sendBulkEmailVarifation,
  shouldRestoreState,
  division,
}) {
  const [anchorEl, setAnchorEl] = useState(null);
  const [anchorElAdd, setAnchorElAdd] = useState(null);
  const [search, setSearch] = useState("");
  const debouncedSearch = useDebounce(search, 500);
  const [contractorStatus, setContractorStatus] = useState("");
  const [page, setPage] = useState(0);
  const [pageSize, setPageSize] = useState(GRID_DEFAULT_PAGE_SIZE);
  const [contractorConfigurationApiData, setContractorConfigurationApiData] =
    useState({
      page: 1,
      pageSize: pageSize,
      search: "",
      Status: "",
      isSendMail: false,
    });

  const [isTableLoading, setisTableLoading] = useState(false);
  const navigate = useNavigate();
  const open = Boolean(anchorEl);
  const id = open ? "simple-popover" : undefined;
  const openAdd = Boolean(anchorElAdd);
  const idAdd = openAdd ? "simple-popover" : undefined;
  const [divisionfilter, setDivisionFilter] = useState("");

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
    window.close();
  };

  const handleautoSearch = (event) => {
    let searchText = "";
    if (event.target.value) {
      searchText = event.target.value;
    }
    setSearch(searchText);
  };

  const handleSearch = (data) => {
    setAnchorEl(null);
    setisTableLoading(true);
    setTimeout(() => {
      setisTableLoading(false);
    }, 1);
    getOnboardedContractorLists(data);
  };
  const handleClear = () => {
    setContractorStatus("");
    setPage(0);
    setPageSize(GRID_DEFAULT_PAGE_SIZE);
    setDivisionFilter("");
    const data = {
      page: 1,
      pageSize: GRID_DEFAULT_PAGE_SIZE,
      search: "",
      Status: "",
      isSendMail: false,
      divisionId: 0,
    };
    setSearch("");
    setContractorStatus("");
    setContractorConfigurationApiData({
      ...contractorConfigurationApiData,
      search: "",
      Status: "",
      isSendMail: false,
      divisionId: 0,
    });
    handleSearch(data);
  };
  const handleApply = (state) => {
    setContractorConfigurationApiData({
      ...contractorConfigurationApiData,
      Status: contractorStatus,
    });
    setAnchorEl(null);
    const data = {
      ...contractorConfigurationApiData,
      page: 1,
      pageSize: pageSize,
      Status: contractorStatus,
      search: search,
      isSendMail: false,
      divisionId: divisionfilter ? divisionfilter : 0,
    };
    setisTableLoading(true);
    setTimeout(() => {
      setisTableLoading(false);
    }, 1);
    getOnboardedContractorLists(data);
  };

  const handlePageSizeChange = (newPazeSize) => {
    setPageSize(newPazeSize);
    const data = {
      ...contractorConfigurationApiData,
      page: 1,
      pageSize: newPazeSize,
      search: search,
      Status: contractorStatus ? contractorStatus : "",
      isSendMail: false,
      divisionId: divisionfilter ? divisionfilter : 0,
    };
    setisTableLoading(true);
    setTimeout(() => {
      setisTableLoading(false);
    }, 1);
    getOnboardedContractorLists(data);
  };

  const handlePagignation = (newPage) => {
    setPage(newPage);
    const data = {
      ...contractorConfigurationApiData,
      page: newPage + 1,
      pageSize: pageSize,
      search: search,
      Status: contractorStatus ? contractorStatus : "",
      isSendMail: false,
      divisionId: divisionfilter ? divisionfilter : 0,
    };
    setContractorConfigurationApiData({
      ...contractorConfigurationApiData,
      page: newPage + 1,
      pageSize: pageSize,
      search: search,
      Status: contractorStatus ? contractorStatus : "",
      isSendMail: false,
    });
    getOnboardedContractorLists(data);
  };

  const handleOnclick = (rows) => {
    if (InactiveClient()) return;
    sessionStorage.setItem("contractorConfigurationListPreserveState", "true");
    if (
      rows.row.status == 1 ||
      rows.row.status == 4 ||
      rows.row.status == 6 ||
      rows.row.status == 7
    ) {
      navigate(ADMIN_CONTRACTOR_CONFIGURATION_VIEW, {
        state: {
          onboardUserId: rows.row.onboardUserId,
          userId: rows.row.userId,
          editMode: true,
        },
      });
    } else if (rows.row.status == 2 || rows.row.status == 5) {
      navigate(ADMIN_CONTRACTOR_CONFIGURATION_EDIT, {
        state: {
          onboardUserId: rows.row.onboardUserId,
          userId: rows.row.userId,
          editMode: true,
        },
      });
    }
  };

  const handleResendOnClick = (rows) => {
    if (InactiveClient()) return;
    const data = {
      userid: rows.row.onboardUserId,
    };
    recreateUsersList(data);
  };

  const contractorStatusOnChanges = (e) => {
    setContractorStatus(e.target.value);
  };

  function getColorCode(status) {
    let colors;
    if (status === 2 || status === 5) {
      colors = "Crimson";
    }
    return colors;
  }

  const columns = [
    { field: "onboardUserId", headerName: "Subcontractor ID", flex: 2 },
    { field: "contractorName", headerName: "Subcontractor Name", flex: 2.7 },
    {
      field: "statusText",
      headerName: "Status",
      flex: 3.5,
      renderCell: (rows) => {
        return (
          <div style={{ color: getColorCode(rows?.row?.status) }}>
            {rows?.row?.status === 7
              ? "Contractor Login Successfully"
              : rows?.row?.status === 6
                ? "Disable Contractor in Cognito"
                : rows?.row?.status === 0
                  ? "Contractor Onboarded"
                  : rows?.row?.statusText}
          </div>
        );
      },
    },
    {
      field: "pocEmail",
      headerName: "Email ID",
      flex: 3.3,
      renderCell: (rows) => {
        const email = rows?.row?.pocEmail || "";

        return (
          <div
            style={{
              display: "flex",
              alignItems: "center",
              gap: "5px",
              width: "100%",
            }}
          >
            <div
              title={email}
              style={{
                whiteSpace: "nowrap",
                overflow: "hidden",
                textOverflow: "ellipsis",
                flex: 1,
                minWidth: "0",
                textAlign: "left",
              }}
            >
              {email}
            </div>
          </div>
        );
      },
    },
    {
      field: "isEmailVerified",
      headerName: "Verified Email",
      flex: 1.9,
      renderCell: (rows) => {
        return rows?.row?.isEmailVerified ? (
          <img src={check_Icon} alt="Verified" width="16" height="16" />
        ) : (
          <img src={cross_Icon} alt="Not Verified" width="18" height="18" />
        );
      },
    },
    {
      field: "icon",
      renderHeader: () => "",
      flex: 1.2,
      sortable: false,
      disableClickEventBubbling: true,
      renderCell: (rows) => {
        return (
          <ReportRowManipulte
            rows={rows}
            editOnClick={() => handleOnclick(rows)}
            edit={checkPrivileges([12, 43, 44])}
            editLabel="Edit Subcontractor"
            resendEmail={rows.row.status == 4}
            resendEmailLable={"Resend welcome email"}
            resendEmailOnClick={() => handleResendOnClick(rows)}
            verifyEmail={!rows.row.isEmailVerified}
            verifyEmailLable={"Verify Email"}
            verifyEmailOnClick={() => sendBulkEmailVarifation(rows)}
          />
        );
      },
    },
  ];

  const [accessContractorId, setAccessContractorId] = useState([]);
  const handleClickGrantAccess = () => {
    if (InactiveClient()) return;
    const accessData = {
      contractorIds: accessContractorId,
    };
    updateOnboardedContractorList(accessData);
  };

  const sendEmail = () => {
    if (InactiveClient()) return;
    const data = {
      ...contractorConfigurationApiData,
      page: page,
      pageSize: pageSize,
      search: search,
      Status: contractorStatus ? contractorStatus : "",
      isSendMail: true,
      divisionId: divisionfilter ? divisionfilter : 0,
    };
    setContractorConfigurationApiData(data);
    getOnboardedContractorLists(data);
  };

  useEffect(() => {
    if (shouldRestoreState && OnboardedContractorListDataList?.filterObjs) {
      const f = OnboardedContractorListDataList.filterObjs;
      setSearch(f.search || "");
      setContractorStatus(f.Status || "");
      setPage((f.page || 1) - 1);
      setPageSize(f.pageSize || GRID_DEFAULT_PAGE_SIZE);
      setDivisionFilter(f.divisionId === 0 ? "" : f.divisionId || "");
    } else if (shouldRestoreState === false) {
      setSearch("");
      setContractorStatus("");
      setPage(0);
      setPageSize(GRID_DEFAULT_PAGE_SIZE);
      setDivisionFilter("");
    }
  }, [shouldRestoreState]);

  const isFirstRender = useRef(true);

  useEffect(() => {
    if (isFirstRender.current) {
      isFirstRender.current = false;
      return;
    }
    const data = {
      page: 1,
      pageSize: pageSize,
      search: debouncedSearch ? debouncedSearch : "",
      orgId: ORG_ID(),
      Status: contractorStatus,
      isSendMail: false,
      divisionId: divisionfilter ? divisionfilter : 0,
    };
    setisTableLoading(true);
    setTimeout(() => {
      setisTableLoading(false);
    }, 1);
    getOnboardedContractorLists(data);
  }, [debouncedSearch]);

  const divisionFilterOnChanges = (e) => {
    setDivisionFilter(e?.target?.value);
  };
  return (
    <>
      <section className="grid_main_sec">
        <div className="grid_main_header two_grid">
          <div className="grid_heading_style">Subcontractor Configuration</div>
          <div>
            <div className="filter_btn">
              {checkPrivileges([12, 43, 44]) && (
                <Buttons
                  id="btnAddUsers"
                  aria-describedby={idAdd}
                  varientContained={true}
                  label={"Grant Access"}
                  onClick={(e) => handleClickGrantAccess()}
                />
              )}
            </div>
          </div>
        </div>
        <div className="grid_main_body">
          <div className="div-filter-container">
            <div className="filter_of_caselist">
              <div className="searchcaseid">
                <label htmlFor="search">
                  <span>
                    <SearchIcon />
                  </span>
                  <div>
                    <input
                      id="search"
                      placeholder="Search"
                      type="text"
                      value={search}
                      className=""
                      onChange={handleautoSearch}
                      autoComplete="off"
                    />
                  </div>
                </label>
              </div>
              <div className="filter_btn">
                <button
                  aria-describedby={id}
                  variant="contained"
                  type="button"
                  name="btn"
                  onClick={(e) => handleClick(e)}
                >
                  <FilterListIcon id="icn" /> Filters
                </button>
                <UserFilterList
                  secondLabel="Status"
                  id={id}
                  open={open}
                  anchorEl={anchorEl}
                  handleClose={handleClose}
                  secondLebelValue={contractorStatus}
                  handleSearch={handleSearch}
                  handleApply={handleApply}
                  handleClear={handleClear}
                  secondLebelFilter={onboardContractorStatus}
                  resetBtn={true}
                  secondLebelOnChanges={contractorStatusOnChanges}
                  thirdLebelFilter={division}
                  thirdLabel="Division"
                  thirdLebelOnChanges={divisionFilterOnChanges}
                  thirdLebelValue={divisionfilter}
                  isShow={true}
                />
              </div>
            </div>
            <div className="div-download-email-right" onClick={sendEmail}>
              <span>
                <img
                  src={downloadIcon}
                  className="DownLoadLogo"
                  alt="DownLoad Logo"
                />
              </span>
              Download Data
            </div>
          </div>
          {isTableLoading ? (
            ""
          ) : (
            <div className="desc_box row_uniq">
              <div className="table_style_ui">
                <GridTable
                  getRowId={(r) => r.onboardUserId}
                  rows={OnboardedContractorListData?.data?.contractorData ?? []}
                  rowCount={OnboardedContractorListData?.data?.itemsCount ?? 0}
                  columns={columns}
                  loading={loading}
                  components={{
                    LoadingOverlay: TableLoader,
                    NoRowsOverlay: NORow,
                  }}
                  checkboxSelection
                  page={page}
                  pagination
                  pageSize={pageSize}
                  rowsPerPageOptions={ROW_PER_PAGE_SIZE}
                  onPageSizeChange={handlePageSizeChange}
                  onPageChange={handlePagignation}
                  backIconButtonProps={{ disabled: false }}
                  disableSelectionOnClick
                  onSelectionModelChange={setAccessContractorId}
                  isRowSelectable={(rows) =>
                    rows.row.status == 1 || rows.row.status == 5
                  }
                />
              </div>
            </div>
          )}
        </div>
      </section>
    </>
  );
}

export default ContractorConfigurationList;
